import { GridColumnType } from "../../../../../data/gridColumnType";

export const verifiedCompetencyConfig = {
    columns: [
        {
            name: "Type of Competency",
            fieldName: "competencyName",
            allowShort: false,
            colType: GridColumnType.Text,
        },

        {
            name: "Submitted Date",
            fieldName: "createdAt",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Approved Date",
            fieldName: "approvedDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Status",
            fieldName: "statusName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Display",
            fieldName: "isDisplay",
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false,
                isDisabled: (rowData) => rowData?.statusName !== "Approved"
            },
            allowShort: false
        },
    ],
}
